'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// ./~/.0.2.1@querystring-es3/index.js
// module id = 142
// module chunks = 2